import React from 'react';
import styled from 'styled-components';

import SpodialLogo from 'static/images/landingMarketPlace/spodialBird.webp'; // Предполагаем, что у вас есть это изображение

export const AudienceSection = () => {
    return (
        <AudienceWrapper>
            <ContentCard>
                <ContentContainer>
                    <TitleContainer>
                        <Title>Соберите вашу аудиторию в одном месте!</Title>
                        <LogoContainer src={SpodialLogo} alt='Spodial logo' />
                    </TitleContainer>
                    <Description>
                        Наш сервис поможет вам собрать аудиторию в Telegram, где
                        ваш ИИ-ассистент сможет помогать выбирать товары,
                        отвечать на вопросы, формировать персональные
                        рекомендации
                    </Description>
                </ContentContainer>
            </ContentCard>
        </AudienceWrapper>
    );
};

const AudienceWrapper = styled.section`
    padding: 80px 0;
    width: 100%;
`;

const ContentCard = styled.div`
    padding: 48px;
    border-radius: 30px;
    background: #fff;

    box-shadow: 0px 0px 35.1px 0px rgba(27, 0, 162, 0.19);
    position: relative;
`;

const ContentContainer = styled.div`
    // max-width: 900px;
`;

const TitleContainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 24px;

    position: relative;
`;

const Title = styled.h2`
    font-size: 34px;
    font-weight: 700;
    line-height: 1.2;
    color: #1a1a1a;
    margin: 0 0 12px;
    font-family: 'Unbounded';

    @media (max-width: 992px) {
        font-size: 28px;
        text-align: center;
        margin-bottom: 12px;
        br {
            display: none;
        }
    }
`;

const LogoContainer = styled.img`
    width: 152px;
    height: 150px;
    position: absolute;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    right: -63px;
    top: -100px;
`;

const Description = styled.p`
    font-size: 20px;
    line-height: 1.5;
    color: #666666;
    margin: 0;
    max-width: 800px;
`;

// Добавляем медиа-запросы для адаптивности
const media = {
    tablet: '@media (max-width: 992px)',
    mobile: '@media (max-width: 576px)',
};

// Применяем медиа-запросы к компонентам
const ResponsiveTitle = styled(Title)`
    ${media.tablet} {
        font-size: 36px;
    }
    ${media.mobile} {
        font-size: 28px;
    }
`;

const ResponsiveDescription = styled(Description)`
    ${media.tablet} {
        font-size: 18px;
    }
    ${media.mobile} {
        font-size: 16px;
    }
`;

const ResponsiveContentCard = styled(ContentCard)`
    ${media.tablet} {
        padding: 32px;
    }
    ${media.mobile} {
        padding: 24px;
        border-radius: 16px;
    }
`;
